// extracted by mini-css-extract-plugin
module.exports = {"root":"b1ddd01198--root--ch180","phone":"b1ddd01198--phone--fu9cH","about":"b1ddd01198--about--a43et","operator":"b1ddd01198--operator--J4Dez"};